// Pages refetched after a review can shift a patient across a page boundary; keep its first copy.
export function uniqueByPatient<T extends { patientId: string }>(rows: readonly T[]): T[] {
    const seen = new Set<string>();
    return rows.filter((row) => {
        if (seen.has(row.patientId)) return false;
        seen.add(row.patientId);
        return true;
    });
}
